import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import "rc-slider/assets/index.css";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { setCurrentPageTitle } from "../../../../store/slices/pageSlice";
import {
  fetchHardwareDescriptions,
  replaceAllHardwareDescriptions,
} from "../../../../store/slices/hardwareDescriptionSlice";
import { fetchEmployees } from "../../../../store/slices/employeeSlice";
import { fetchWorkEntries } from "../../../../store/slices/workentriesSlice";
import { fetchHardware } from "../../../../store/slices/hardwareSlice";
import {
  getAllAutoSaveWorkentries,
  replaceAllWorkEntries,
} from "../../../../store/slices/autosaveSlice";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { submitWorkEntries } from "../../../../store/slices/submitTaskSlice";
import { fetchDescriptionTasks } from "../../../../store/slices/DescriptionTask";
import { replaceAllDescriptionTasks } from "../../../../store/slices/descriptionTaskSlice";
import FileUploadOP from "../FileUploadOP";
import ActionsOP from "../ActionsOP";
import SubmitLoader from "../../../../components/common/loader/SubmitLoader";
import AdminLoader from "./../../../../components/common/loader/AdminLoader";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { fetchLeads } from "../../../../store/slices/leadsSlice";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { setPersonReadTrue } from "../../../../store/slices/readSlice";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import DateConversion from "../../../../utils/DateConversion";
import CommaConvert from "../../../../utils/CommaConvert";
import {
  formatAmountComma,
  formatAmountForInput,
  validateAmountValue,
  parseAmountNumber,
} from "../../../../utils/decimalAmountUtils";
import { updateTaskStatus } from "../../../../store/slices/projectTaskStatusSlice";
import { getAllAssemblyInventory } from "../../../../store/slices/assemblyInventorySlice";
import { fetchGroups } from "../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../store/slices/MyTraining/myTrainings";
import {
  applyLiveTrainingTotalToOtherExpenseRows,
  consolidateTrainingExpenseRowsForDisplay,
  resolveInstallationOtherExpenseRowsForPersistence,
  getLiveTrainingRollupForOpsAssigneeProject,
  isTrainingExpenseDisplayRow,
  normalizeTaskIdForScope,
  taskProjectIdMatchesOpsManagerResourceScopes,
} from "../../../../utils/trainingOtherExpenseSync";
import useToolGuideSync from "../../../../features/toolGuide/useToolGuideSync";
import { MANAGER_BUCKET_KEYS } from "../../../../features/toolGuide/toolGuideConfig";

const ProjectRequestedOP = ({ filterRequestProjects, handlerefresh, isViewOnly = false }) => {
  const sanitizeDecimalInput = (inputValue) => {
    const cleaned = String(inputValue ?? "").replace(/[^0-9.]/g, "");
    const [integerPart, ...decimalParts] = cleaned.split(".");
    if (decimalParts.length === 0) return integerPart;
    return `${integerPart}.${decimalParts.join("")}`;
  };
  const roundHours = (value) => Number((Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2));
  const dispatch = useDispatch();
  const { syncToolGuideStep } = useToolGuideSync(
    MANAGER_BUCKET_KEYS.PROJECT_REQUESTS,
    "L4_OPS"
  );
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const { formatDateByCountry } = DateConversion();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Operations Persons Dashboard"));
  }, [dispatch]);

  const [acceptedProject, setAcceptedProject] = useState("");
  const emptyRow = React.useMemo(
    () => ({ task: "", hoursassigned: "", notes: "" }),
    []
  );
  const [trackedDebounceTimer, setTrackedDebounceTimer] = useState(null);
  const [fetchedHardwareData, setFetchedHardwareData] = useState([]);
  const [initialEdit, setInitialEdit] = useState(false);
  const [typingTimeout, setTypingTimeout] = React.useState(null);
  const { autosaveentries } = useSelector((state) => state.autosave);
  const [filteredEntries, setFilteredEntries] = useState([]);
  const [rows, setRows] = useState([]);
  const maintaskdivRef = useRef(null);
  const installationtaskdiv = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const popupRef = useRef(null);
  const name = localStorage.getItem("name");
  const lastName = localStorage.getItem("lastName");
  const AssignPerson = name + " " + lastName;
  const [showLogout, setshowlogout] = useState(false);
  const [showprojectDetails, SetShowprojectDetails] = useState(false);
  const [viewTaskSubmitted] = useState(false);
  const [, setSelectedApprovedTasks] = useState([]);
  const [, setFilterCompletedtask] = useState([]);
  const [taskToShow] = useState([]);
  const { completeTask } = useSelector((state) => state.completedTasks);
  const { personOngoingTasks } = useSelector(
    (state) => state.projectOngoingTasks
  );
  const { employees } = useSelector((state) => state.employees);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { projects } = useSelector((state) => state.projects);
  const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
  const [isLoadingtask, SetisLoadingtask] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [isLoading, SetisLoading] = useState(false);
  const [Action, setAction] = useState("task");
  const [hardwareAction, setHardwareAction] = useState();
  const [openDetailsIdx, setOpenDetailsIdx] = useState(null);
  const [triprows, setTripRows] = useState([
    { description: "", value: "", notes: "" },
  ]);
  const [totalDollerValue, settotalDollerValue] = useState(0);
  const [selectedproject, setselectedproject] = useState("");
  const [selectedprojectid, setselectedprojectid] = useState("");
  const projectScopeKey = `${selectedproject ?? ""}|${acceptedProject?._id ?? ""}`;
  const prevProjectScopeRef = useRef(projectScopeKey);
  const [tripRowsUserEditing, setTripRowsUserEditing] = useState(false);
  const [effortRowsUserEditing, setEffortRowsUserEditing] = useState(false);
  const [installationUserEditing, setInstallationUserEditing] = useState(false);

  useEffect(() => {
    if (prevProjectScopeRef.current !== projectScopeKey) {
      prevProjectScopeRef.current = projectScopeKey;
      setTripRowsUserEditing(false);
      setEffortRowsUserEditing(false);
      setInstallationUserEditing(false);
    }
  }, [projectScopeKey]);

  const appendManualOtherExpenseRow = (prev) => {
    const manuals = (prev || []).filter((r) => !isTrainingExpenseDisplayRow(r));
    const trains = (prev || []).filter((r) => isTrainingExpenseDisplayRow(r));
    if (manuals.length >= 15) return prev;
    return [...manuals, { description: "", value: "", notes: "" }, ...trains];
  };

  const lockedTrainingRow = useMemo(() => {
    const loggedEmail = String(localStorage.getItem("email") || "").trim().toLowerCase();
    const loggedEmp = (employees || []).find(
      (e) => String(e?.EmpEmail || "").trim().toLowerCase() === loggedEmail
    );
    if (!loggedEmp?._id || !acceptedProject) return null;
    return getLiveTrainingRollupForOpsAssigneeProject({
      projectRow: acceptedProject,
      assigneeEmp: loggedEmp,
      trainingsEnvelope: mytrainings,
      projects,
      currencySymbol: currency,
    });
  }, [acceptedProject, employees, mytrainings, currency, projects]);

  const lockedTrainingCostTotal = lockedTrainingRow ? Number(lockedTrainingRow.amount) || 0 : 0;
  const lockedTrainingNotes = String(lockedTrainingRow?.notes || "").trim();

  const [installation, setInstallation] = useState([]);
  const hasTrainingRowInExistingExpenses = useMemo(
    () =>
      (triprows || []).some((expenseRow) => isTrainingExpenseDisplayRow(expenseRow)) ||
      (installation || []).some((expenseRow) => isTrainingExpenseDisplayRow(expenseRow)),
    [installation, triprows]
  );
  const shouldShowLockedTrainingRow =
    !hasTrainingRowInExistingExpenses &&
    (lockedTrainingCostTotal > 0 || String(lockedTrainingRow?.notes || "").trim() !== "");
  const [tripduration, setTripDuration] = useState("");
  // moved above to avoid reference-before-init in lockedTrainingRow

  const [serviceofuser, setServiceofuser] = useState("task");
  const [Assignperson, setAssignperson] = useState("");
  const [hardware, setHardware] = useState([]);
  const { leads } = useSelector((state) => state.leads);
  const LoggedUser = localStorage.getItem("email");

  useEffect(() => {
    const hasHardware = Array.isArray(acceptedProject.TypeService)
      ? acceptedProject.TypeService.some((service) =>
        service.includes("Hardware")
      )
      : acceptedProject.TypeService?.includes("Hardware");

    if (hasHardware) {
      setAction("");
      setHardwareAction("hardwarecost");
    } else {
      setAction("task");
      setHardwareAction("");
    }
  }, [acceptedProject?.TypeService]);

  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { inventory } = useSelector((state) => state.assemblyInventory);
  const { group: groups } = useSelector((state) => state.group);

  const groupNameById = useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name =
        g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = useCallback(
    (projectRow) => {
      if (typeof projectRow?.group === "string" && projectRow.group.trim()) {
        return projectRow.group;
      }

      const directGroupName =
        projectRow?.group?.newGroupName ||
        projectRow?.group?.groupname ||
        projectRow?.group?.groupName ||
        projectRow?.group?.name ||
        projectRow?.groupid?.newGroupName ||
        projectRow?.groupid?.groupname ||
        projectRow?.groupid?.groupName ||
        projectRow?.groupid?.name ||
        projectRow?.groupId?.newGroupName ||
        projectRow?.groupId?.groupname ||
        projectRow?.groupId?.groupName ||
        projectRow?.groupId?.name ||
        projectRow?.lead?.groupid?.newGroupName ||
        projectRow?.lead?.groupid?.groupname ||
        projectRow?.lead?.groupid?.groupName ||
        projectRow?.lead?.groupid?.name ||
        projectRow?.lead?.groupId?.newGroupName ||
        projectRow?.lead?.groupId?.groupname ||
        projectRow?.lead?.groupId?.groupName ||
        projectRow?.lead?.groupId?.name;

      if (directGroupName) return directGroupName;

      const groupId =
        projectRow?.group?._id ||
        projectRow?.group?.id ||
        projectRow?.group ||
        projectRow?.groupid?._id ||
        projectRow?.groupid?.id ||
        projectRow?.groupid ||
        projectRow?.groupId?._id ||
        projectRow?.groupId?.id ||
        projectRow?.groupId ||
        projectRow?.lead?.groupid?._id ||
        projectRow?.lead?.groupid?.id ||
        projectRow?.lead?.groupid ||
        projectRow?.lead?.groupId?._id ||
        projectRow?.lead?.groupId?.id ||
        projectRow?.lead?.groupId;

      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }

      return projectRow?.AssignedGroup || "";
    },
    [groupNameById]
  );

  const getProjectGroupId = useCallback((projectRow) => {
    return String(
      projectRow?.group?._id ||
        projectRow?.group?.id ||
        projectRow?.groupid?._id ||
        projectRow?.groupid?.id ||
        projectRow?.groupid ||
        projectRow?.groupId?._id ||
        projectRow?.groupId?.id ||
        projectRow?.groupId ||
        projectRow?.lead?.groupid?._id ||
        projectRow?.lead?.groupid?.id ||
        projectRow?.lead?.groupid ||
        projectRow?.lead?.groupId?._id ||
        projectRow?.lead?.groupId?.id ||
        projectRow?.lead?.groupId ||
        ""
    );
  }, []);

  const isInventoryGroupMatch = useCallback(
    (inventoryEntry, projectRow) => {
      const projectGroupId = getProjectGroupId(projectRow);
      const inventoryGroupId = String(
        inventoryEntry?.groupid?._id ||
          inventoryEntry?.groupid?.id ||
          inventoryEntry?.groupid ||
          inventoryEntry?.groupId?._id ||
          inventoryEntry?.groupId?.id ||
          inventoryEntry?.groupId ||
          ""
      );

      if (projectGroupId && inventoryGroupId) {
        return projectGroupId === inventoryGroupId;
      }

      const selectedGroup = getDisplayGroupName(projectRow);
      if (selectedGroup) {
        return inventoryEntry?.group === selectedGroup;
      }

      return false;
    },
    [getProjectGroupId, getDisplayGroupName]
  );

  useEffect(() => {
    dispatch(getAllAutoSaveWorkentries());
    dispatch(fetchHardware());
    dispatch(fetchWorkEntries());
    dispatch(fetchEmployees());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchLeads());
    dispatch(getAllAssemblyInventory());
    dispatch(fetchGroups());
    dispatch(getMyTrainings());
  }, [dispatch]);

  const handlerefreshagain = React.useCallback(() => {
    dispatch(getAllAutoSaveWorkentries());
    dispatch(fetchHardware());
    dispatch(fetchEmployees());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchLeads());
    dispatch(fetchAllProjects());
    dispatch(fetchDescriptionTasks());
    dispatch(getAllAssemblyInventory());
    dispatch(getMyTrainings());
  }, [dispatch]);

  useEffect(() => {
    if (acceptedProject && acceptedProject.Assignedperson) {
      const userEmail = localStorage.getItem("email"); // or whatever key you use to store email

      const assignedPerson = acceptedProject.Assignedperson.find(
        (person) => person.email === userEmail
      );
      setAssignperson(assignedPerson);
    }
  }, [acceptedProject]);

  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);

    if (currentEmployee && items) {
      const leadLike = acceptedProject?.lead || acceptedProject?.Lead || null;
      const filteredHardware = items?.filter(
        (item) =>
          normalizeTaskIdForScope(item?.taskownerid) ===
            normalizeTaskIdForScope(currentEmployee?._id) &&
          taskProjectIdMatchesOpsManagerResourceScopes(
            { projectid: item.projectid, taskownerid: item.taskownerid },
            acceptedProject,
            leadLike
          )
      );

      if (filteredHardware?.length) {
        setHardware(filteredHardware);
      } else {
        setHardware([
          {
            assemblepartdescription: "",
            partno: "",
            quantity: "",
            unitprice: "",
            totalprice: "",
          },
        ]);
      }
    }
  }, [items, acceptedProject, employees]);
  useEffect(() => {
    if (!acceptedProject || !inventory || !employees) return;

    console.log("sdgsdgsd inventory", inventory);

    console.log("sdgsdgsd", acceptedProject);

    // Safely access the first element of AssignedManagerEmail array
    const userEmail =
      Array.isArray(acceptedProject?.AssignedManagerEmail) &&
        acceptedProject?.AssignedManagerEmail?.length > 0
        ? acceptedProject?.AssignedManagerEmail[0]
        : null;

    console.log("sdgsdgsd userEmail", userEmail);

    if (!userEmail) {
      setFetchedHardwareData([]);
      return;
    }

    const currentEmployee = employees?.find(
      (emp) => emp?.EmpEmail === userEmail
    );

    if (!currentEmployee) {
      setFetchedHardwareData([]);
      return;
    }

    // const matchedtaskEntries = inventory?.filter(
    //   (entry) =>
    //     entry.group === acceptedProject?.AssignedGroup &&
    //     entry.createdBy === currentEmployee?._id
    // );
    // console.log("sdgsdgsd matchedtaskEntries", matchedtaskEntries);

    // Assembly dropdown: show only assemblies whose group matches this project group
    const matchedtaskEntries = inventory.filter((entry) =>
      isInventoryGroupMatch(entry, acceptedProject)
    );
    

    const newhardwareRows = matchedtaskEntries?.map((hardware) => ({
      _id: hardware._id,
      assemblepartdescription: hardware.assembly || "",
      partnumber: hardware.partnumber || "",
      unitprice: hardware.unitprice || "",
    }));

    setFetchedHardwareData(newhardwareRows);
  }, [inventory, acceptedProject, employees, isInventoryGroupMatch]);

  const [totalHoursAssigned, setTotalHoursAssigned] = useState(0);
  useEffect(() => {
    const total = filteredEntries.reduce((sum, entry) => {
      return sum + (parseFloat(entry.hoursassigned) || 0);
    }, 0);
    setTotalHoursAssigned(roundHours(total));
  }, [filteredEntries]);

  const handledirectSubmit = async () => {
    if (isViewOnly) return;
    const serviceType = acceptedProject?.TypeService?.toLowerCase();

    if (serviceType.includes('installation') && !tripduration) {
      return
    }
    const email = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const projectid = selectedprojectid;
    const taskownerid = currentEmployee?._id;
    if (!projectid || !taskownerid) {
      return;
    }
    try {
      await dispatch(submitWorkEntries({ projectid, taskownerid }));
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      setselectedprojectid("");
    }
  };

  useEffect(() => {
    const name = localStorage.getItem("name");
    const lastName = localStorage.getItem("lastName");
    const AssignPerson = name + " " + lastName;
    const filteredProjects = projects.filter(
      (project) =>
        project.OperationStatus === "project Approved" &&
        project.Assignedperson?.some((person) => person.name === AssignPerson)
    );
    setSelectedApprovedTasks(filteredProjects);
  }, [projects]);

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchDescriptionTasks());
  }, [dispatch, AssignPerson]);

  useEffect(() => {
    const name = localStorage.getItem("name");
    const lastName = localStorage.getItem("lastName");
    const AssignPerson = name + " " + lastName;
    if (Array.isArray(completeTask)) {
      const result = completeTask.filter(
        (task) => task.assignedPerson === AssignPerson
      );
      setFilterCompletedtask(result);
    }
  }, [completeTask]);

  const groupedOngoingArray = Object.values(
    personOngoingTasks.reduce((acc, task) => {
      const project = task.projectName;
      if (!acc[project]) {
        acc[project] = {
          projectName: project,
          TypeService: task.TypeService,
          tasks: [],
          totalHours: 0,
          totalHoursSpent: 0,
          validTaskCount: 0,
        };
      }
      acc[project].tasks.push(task);

      // Only consider tasks where 'hoursspent' exists and is not 0
      if (task.hoursspent != null && task.hoursspent !== 0) {
        acc[project].totalHours += task.hours || 0;
        acc[project].totalHoursSpent += task.hoursspent || 0;
        acc[project].validTaskCount += 1; // Count only valid tasks
      }

      return acc;
    }, {})
  );
  // Now calculate averageHours for each project
  groupedOngoingArray.forEach((group) => {
    const { totalHours, totalHoursSpent, validTaskCount } = group;

    if (totalHours > 0 && validTaskCount > 0) {
      group.averageHours =
        ((totalHoursSpent / totalHours) * 100) / validTaskCount;
    } else {
      group.averageHours = 0;
    }

    // Optional: Round to 2 decimal places
    group.averageHours = Number(group.averageHours.toFixed(2));

    // Clean up temp totals
    delete group.totalHours;
    delete group.totalHoursSpent;
    delete group.validTaskCount;
  });

  const dropdownRefsProbability = useRef([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openProbabilityIndex !== null &&
        dropdownRefsProbability.current[openProbabilityIndex] &&
        !dropdownRefsProbability.current[openProbabilityIndex].contains(
          event.target
        )
      ) {
        setOpenProbabilityIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openProbabilityIndex]);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);

  useEffect(() => {
    if (!effortRowsUserEditing && rows.length === 0) {
      setRows([{ task: "", hoursassigned: "", notes: "" }]);
    }
  }, [rows, effortRowsUserEditing]);

  useEffect(() => {
    if (!tripRowsUserEditing && triprows.length === 0) {
      setTripRows([{ description: "", value: "", notes: "" }]);
    }
  }, [triprows, tripRowsUserEditing]);

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;

    // Create a deep copy of the rows array
    const updatedRows = rows.map((row) => ({ ...row }));

    if (name === "hoursassigned") {
      const sanitizedValue = sanitizeDecimalInput(value);
      const numericValue = sanitizedValue === "" ? null : Number(sanitizedValue);
      if (numericValue !== null && numericValue > 112) return;
      updatedRows[index][name] = sanitizedValue;
    } else if (name === "notes") {
      // Only allow letters and spaces, limit to 40 characters
      const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, "").slice(0, 40);
      updatedRows[index][name] = filteredValue;
    } else if (name === "task") {
      // Only allow letters, numbers, and spaces
      const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
      updatedRows[index][name] = filteredValue;
    } else {
      updatedRows[index][name] = value;
    }

    setRows(updatedRows);
  };

  const handleAddRow = () => {
    if (rows.length < 15) {
      setEffortRowsUserEditing(true);
      setInitialEdit(true);
      setRowAdded(true);
      setRows([...rows, { ...emptyRow }]); // Spread the emptyRow to create a new object
    } else {
      enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
    }
  };
  const handleRemoveRow = (index) => {
    setEffortRowsUserEditing(true);
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    const sum = updatedRows.reduce((acc, row) => {
      const hours = parseFloat(row.hoursassigned) || 0;
      return acc + hours;
    }, 0);

    setTotalHoursAssigned(roundHours(sum));
    setTimeout(() => {
      handleCreateTask(updatedRows); // Pass the updated rows directly
    }, 2000);
  };

  const [, setLoggedEmp] = useState(null);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email");
    const loggedInEmployee = employees.find(
      (emp) => emp.EmpEmail === loggedInUserEmail
    );
    setLoggedEmp(loggedInEmployee);
  }, [employees]);
  const alertRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (alertRef.current && !alertRef.current.contains(event.target)) {
        setshowAlert(showAlert);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAlert]);

  const [rowAdded, setRowAdded] = useState(false);

  // Track row additions
  const handleAddRowTracked = () => {
    handleAddRow();
    setRowAdded(true);
  };

  const handleInputChangeTracked = (index, e) => {
    setEffortRowsUserEditing(true);
    // First call the original handleInputChange
    handleInputChange(index, e);

    // Track initial edit state
    if (!initialEdit && rows[index].createdBy === undefined) {
      setInitialEdit(true);
    }

    // Clear any existing timer
    if (trackedDebounceTimer) {
      clearTimeout(trackedDebounceTimer);
    }
    const updatedRows = [...rows];

    if (e.target.name === "hoursassigned") {
      // Calculate the new total by replacing the old value in the row
      updatedRows[index].hoursassigned = sanitizeDecimalInput(e.target.value);

      const sum = updatedRows.reduce((acc, row) => {
        const hours = parseFloat(row.hoursassigned) || 0;
        return acc + hours;
      }, 0);
      setTotalHoursAssigned(roundHours(sum));
    }
    const timer = setTimeout(() => {
      handleCreateTask(updatedRows);
    }, 2000);

    setTrackedDebounceTimer(timer);
    // }
  };

  const handleCreateTask = React.useCallback(
    async (rowsToSubmit) => {
      if (isViewOnly) return;
      const filteredRows = rowsToSubmit.filter((entry) => {
        return (
          (entry.task && entry.task.trim() !== "") ||
          (entry.hoursassigned &&
            entry.hoursassigned.toString().trim() !== "") ||
          (entry.notes && entry.notes.trim() !== "")
        );
      });

      const invalidRows = filteredRows.filter(row => {
        const hasDescription = row.task && row.task.trim() !== "";
        const hasValue = row.hoursassigned !== undefined && row.hoursassigned !== null && row.hoursassigned.toString().trim() !== "";
        return !hasDescription || !hasValue;
      });

      if (invalidRows.length > 0) {
        return;
      }

      const projectid = acceptedProject._id;
      const cleanedData = filteredRows.map((entry) => ({
        task: entry.task || "",
        hoursassigned: Number(entry.hoursassigned) || 0,
        notes: entry.notes || "",
      }));
      SetisLoadingtask(true);
      try {
        await dispatch(
          replaceAllWorkEntries({
            projectid: projectid,
            newEntries: cleanedData,
            tasktype: "self",
          })
        );
      } catch (error) {
        console.error("Failed to create task:", error);
      } finally {
        SetisLoadingtask(false);
        setEffortRowsUserEditing(false);
        dispatch(getAllAutoSaveWorkentries());
      }
      dispatch(fetchAllProjects());
    },
    [acceptedProject, dispatch, isViewOnly]
  );

  useEffect(() => {
    return () => {
      if (trackedDebounceTimer) {
        clearTimeout(trackedDebounceTimer);
      }
    };
  }, [trackedDebounceTimer]);

  const handleInstallationChange = (index, field, value) => {
    setInstallationUserEditing(true);
    const nextValue = field === "value" ? validateAmountValue(value) : value;
    setInstallation((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: nextValue,
      };

      // Calculate total inside setState to ensure we have latest data
      if (field === "value") {
        const total = updated.reduce((sum, row) => {
          return sum + parseAmountNumber(row.value);
        }, 0);
        settotalDollerValue(total);
      }
      return updated;
    });
    setRowAdded(true);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      // Use functional update to get the latest installation state
      setInstallation((latestInstallation) => {
        handleinstallationtaskSubmitauto(tripduration, latestInstallation);
        return latestInstallation; // Return unchanged since we're just using the value
      });
    }, 2000);

    setTypingTimeout(newTimeout);
  };
  const handletripdurationChange = (numericValue) => {
    setInstallationUserEditing(true);
    setTripDuration(numericValue);

    setRowAdded(true);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout
    const newTimeout = setTimeout(() => {
      handleinstallationtaskSubmitauto(numericValue);
    }, 2000); // 2 seconds

    setTypingTimeout(newTimeout);
  };

  const handleinstallationtaskSubmitauto = React.useCallback(
    async (numericValue, installationData = null) => {
      if (isViewOnly) return;
      const dataToSave = installationData || installation;
      const filteredRows = resolveInstallationOtherExpenseRowsForPersistence(
        dataToSave || [],
        acceptedProject,
        { forSubmit: false }
      );
      const invalidRows =
        filteredRows.length > 0
          ? filteredRows.filter(
              (row) => !(row.description && row.description.trim() !== "")
            )
          : [];

      if (invalidRows.length > 0) {
        return;
      }

      SetisLoadingtask(true);
      try {
        const projectID = acceptedProject._id;
        const formdata = filteredRows.map((row) => ({
          ...row,
          value: parseAmountNumber(row.value),
          taskstatus: "submit",
          tripduration: numericValue || filteredRows[0]?.tripduration,
        }));

        await dispatch(
          replaceAllDescriptionTasks({
            projectid: projectID,
            tasktype: "self",
            entries: [...formdata],
          })
        );
      } catch (error) {
        console.error("Operation failed:", error);
      } finally {
        SetisLoadingtask(false);
        setRowAdded(false);
        setInitialEdit(false);
        setInstallationUserEditing(false);
        dispatch(fetchDescriptionTasks());
        handlerefresh();
      }
    },
    [dispatch, acceptedProject, handlerefresh, installation, isViewOnly]
  );

  const handleinstallationtaskSubmit = React.useCallback(
    async (numericValue) => {
      if (isViewOnly) return;
      if (!numericValue && !installation[0]?.tripduration) {
        enqueueSnackbar("Please add tripduration.", {
          variant: "error",
        })
        return;
      }
      SetisLoadingtask(true);
      try {
        const projectID = acceptedProject._id;
        const rowsToSave = resolveInstallationOtherExpenseRowsForPersistence(
          installation || [],
          acceptedProject,
          { forSubmit: true }
        );
        const formdata = rowsToSave.map((row) => ({
          ...row,
          value: parseAmountNumber(row.value),
          taskstatus: "submit",
          tripduration: numericValue || installation[0]?.tripduration,
        }));
        await dispatch(
          replaceAllDescriptionTasks({
            projectid: projectID,
            tasktype: "self",
            entries: [...formdata],
          })
        );
      } catch (error) {
        console.error("Operation failed:", error);
      } finally {
        SetisLoadingtask(false);
        setRowAdded(false);
        setInitialEdit(false);
        handlerefreshagain();
        handlerefresh();
        setselectedprojectid("");
      }
    },
    [dispatch, enqueueSnackbar, installation, handlerefresh, acceptedProject, handlerefreshagain, isViewOnly]
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        installationtaskdiv.current &&
        !installationtaskdiv.current.contains(event.target)
      ) {
        if (rowAdded) {
          handleinstallationtaskSubmitauto(tripduration);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleinstallationtaskSubmitauto, rowAdded, tripduration]);

  const validateDescriptionOrNotes = (value) => {
    return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
  };
  // for softwware and cloud otherexpenses
  const handletaskSubmit = React.useCallback(async () => {
    if (isViewOnly) return;

    const hasEmptyFields = triprows.some((row) => {
      return (
        !row.description?.trim() ||
        !row.notes?.trim() ||
        row.value === "" ||
        row.value === null ||
        row.value === undefined
      );
    });
    if (hasEmptyFields) {
      return;
    }
    SetisLoadingtask(true);
    try {
      const projectId = acceptedProject._id;

      const formdata = triprows.map((row) => ({
        ...row,
        value: parseAmountNumber(row.value),
        taskstatus: "submit",
        // Tag by assigned group so Cloud OP sees only Cloud expenses
        assignedGroup: getDisplayGroupName(acceptedProject) || "",
      }));
      await dispatch(
        replaceAllDescriptionTasks({
          projectid: projectId,
          tasktype: "self",
          entries: [...formdata],
        })
      );
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setRowAdded(false);
      setInitialEdit(false);
      SetisLoadingtask(false);
      handlerefreshagain();
      handlerefresh();
      setselectedprojectid("");
    }
  }, [triprows, dispatch, acceptedProject, handlerefreshagain, handlerefresh, isViewOnly, getDisplayGroupName]);

  const handletaskSubmitAuto = React.useCallback(
    async (newRows) => {
      if (isViewOnly) return;
      const filteredRows = newRows.filter((row) => {
        return (
          (row.description && row.description.trim() !== "") ||
          (row.value && row.value.toString().trim() !== "") ||
          (row.notes && row.notes.trim() !== "")
        );
      });
      const invalidRows = filteredRows.filter(row => {
        const hasDescription = row.description && row.description.trim() !== "";
        const hasValue = row.value !== undefined && row.value !== null && row.value.toString().trim() !== "";
        return !hasDescription || !hasValue;
      });

      if (invalidRows.length > 0) {
        return;
      }
      SetisLoadingtask(true);
      try {
        const projectId = acceptedProject._id;

        const formdata = filteredRows.map((row) => ({
          ...row,
          value: parseAmountNumber(row.value),
          taskstatus: "submit",
          // Tag by assigned group so Cloud / Installation OP expenses stay separate
          assignedGroup: getDisplayGroupName(acceptedProject) || "",
        }));
        await dispatch(
          replaceAllDescriptionTasks({
            projectid: projectId,
            tasktype: "self",
            entries: [...formdata],
          })
        );
      } catch (error) {
        console.error("Operation failed:", error);
      } finally {
        setRowAdded(false);
        setInitialEdit(false);
        setTripRowsUserEditing(false);
        SetisLoadingtask(false);
        dispatch(fetchDescriptionTasks());
      }
    },
    [dispatch, acceptedProject, isViewOnly, getDisplayGroupName]
  );

  const handleInputChanged = (index, field, value) => {
    setTripRowsUserEditing(true);
    const nextValue = field === "value" ? validateAmountValue(value) : value;
    const newRows = [...triprows];
    newRows[index][field] = nextValue;
    setTripRows(newRows);
    setInitialEdit(true);

    if (field === "value") {
      const total = newRows.reduce((sum, row) => {
        return sum + parseAmountNumber(row.value);
      }, 0);
      settotalDollerValue(total);
    }

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout
    const newTimeout = setTimeout(() => {
      handletaskSubmitAuto(newRows);
    }, 2000); // 2 seconds

    setTypingTimeout(newTimeout);
  };
  const handleAddRows = () => {
    setRowAdded(true);
    setTripRowsUserEditing(true);
    setTripRows((prev) => {
      const manuals = (prev || []).filter((r) => !isTrainingExpenseDisplayRow(r));
      if (manuals.length >= 15) return prev;
      return appendManualOtherExpenseRow(prev);
    });
  };
  const handleRemoveRows = () => {
    setTripRowsUserEditing(true);
    // if (triprows.length <= 1) return; // Minimum 1 row
    const newRows = [...triprows];

    newRows.pop();
    const total = newRows.reduce((sum, row) => {
      return sum + parseAmountNumber(row.value);
    }, 0);

    settotalDollerValue(total);
    setTripRows(newRows);
    setRowAdded(true);
    setTimeout(() => {
      handletaskSubmitAuto(newRows); // Pass the updated rows directly
    }, 2000);
  };

  useEffect(() => {
    const userEmail = localStorage.getItem("email"); // Make sure you're storing the email with this key
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    const employeeId = currentEmployee?._id;
    const leadLike = acceptedProject?.lead || acceptedProject?.Lead || null;
    const matchedTasks = tasks.filter(
      (task) =>
        taskProjectIdMatchesOpsManagerResourceScopes(task, acceptedProject, leadLike) &&
        (!employeeId ||
          normalizeTaskIdForScope(task?.taskownerid) === normalizeTaskIdForScope(employeeId))
    );

    const moveMiscellaneousInstallRowToEnd = (rows = []) => {
      const miscIndex = rows.findIndex((r) =>
        String(r?.description || "")
          .toLowerCase()
          .includes("miscellaneous install items")
      );
      if (miscIndex === -1) return rows;
      const miscRow = rows[miscIndex];
      return [...rows.slice(0, miscIndex), ...rows.slice(miscIndex + 1), miscRow];
    };

    if (installationUserEditing) return;

    if (matchedTasks.length) {
      let rowsOut = moveMiscellaneousInstallRowToEnd(
        consolidateTrainingExpenseRowsForDisplay(matchedTasks)
      );
      if (lockedTrainingCostTotal > 0) {
        rowsOut = applyLiveTrainingTotalToOtherExpenseRows(
          rowsOut,
          lockedTrainingCostTotal,
          lockedTrainingNotes,
          currency
        );
      }
      setInstallation(rowsOut);
      setTripDuration(matchedTasks[0]?.tripduration);
    } else {
      setInstallation([
        { description: `Airfare (${currency})`, value: "", notes: "" },
        { description: `Car Rental (${currency})`, value: "", notes: "" },
        { description: `Car fuel (${currency})`, value: "", notes: "" },
        { description: `Lodging (${currency})`, value: "", notes: "" },
        {
          description: `Miscellaneous Install Items to buy (${currency})`,
          value: "",
          notes: "",
        },
      ]);
    }
  }, [
    selectedproject,
    acceptedProject,
    tasks,
    employees,
    currency,
    lockedTrainingCostTotal,
    lockedTrainingNotes,
    installationUserEditing,
  ]);

  const [, setLoggedEmpOP] = useState(null);
  useEffect(() => {
    // Get the logged-in user's email from localStorage
    const loggedInUserEmail = localStorage.getItem("email"); // Assuming you store email as 'userEmail'

    if (selectedproject && tasks.length > 0 && loggedInUserEmail) {
      // Find the employee with matching email
      const loggedInEmployee = employees.find(
        (emp) => emp.EmpEmail === loggedInUserEmail
      );
      setLoggedEmpOP(loggedInEmployee);
      if (loggedInEmployee) {
        if (tripRowsUserEditing) return;
        const leadLike = acceptedProject?.lead || acceptedProject?.Lead || null;
        const matchedTasks = tasks.filter((task) =>
          taskProjectIdMatchesOpsManagerResourceScopes(task, acceptedProject, leadLike)
        );

        // Then filter tasks that were created by this employee
        const employeeSpecificTasks = matchedTasks.filter(
          (task) =>
            normalizeTaskIdForScope(task?.taskownerid) ===
            normalizeTaskIdForScope(loggedInEmployee._id)
        );

        // Convert matched tasks into triprows format
        let newTripRows = consolidateTrainingExpenseRowsForDisplay(employeeSpecificTasks.map((task) => ({
          description: task.description || "",
          value: task.value || "",
          notes: task.notes || "",
        })));
        if (lockedTrainingCostTotal > 0) {
          newTripRows = applyLiveTrainingTotalToOtherExpenseRows(
            newTripRows,
            lockedTrainingCostTotal,
            lockedTrainingNotes,
            currency
          );
        }
        const total = newTripRows.reduce((sum, row) => {
          return sum + parseAmountNumber(row.value);
        }, 0);
        settotalDollerValue(total);
        setTripRows(
          newTripRows.length > 0
            ? [...newTripRows]
            : [{ description: "", value: "", notes: "" }]
        );
        // setTripRows(newTripRows.length > 0 ? newTripRows : [{ description: "", value: "", notes: "" }]);
      }
    }
  }, [
    selectedproject,
    acceptedProject,
    tasks,
    employees,
    currency,
    lockedTrainingCostTotal,
    lockedTrainingNotes,
    tripRowsUserEditing,
  ]);

  useEffect(() => {
    if (!acceptedProject?._id) return;

    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);

    if (!currentEmployee) return;

    const currentProjectGroupId = getProjectGroupId(acceptedProject);
    const leadLike = acceptedProject?.lead || acceptedProject?.Lead || null;

    const matchedtaskEntries = autosaveentries.filter(
      (entry) =>
        taskProjectIdMatchesOpsManagerResourceScopes(
          { projectid: entry.projectid, taskownerid: entry.taskownerid },
          acceptedProject,
          leadLike
        ) &&
        normalizeTaskIdForScope(entry?.taskownerid) ===
          normalizeTaskIdForScope(currentEmployee._id)
    );
    const matchedexpensesEntries = tasks.filter(
      (entry) =>
        taskProjectIdMatchesOpsManagerResourceScopes(entry, acceptedProject, leadLike) &&
        normalizeTaskIdForScope(entry?.taskownerid) ===
          normalizeTaskIdForScope(currentEmployee._id) &&
        (!currentProjectGroupId ||
          !entry.groupid ||
          String(entry.groupid) === currentProjectGroupId)
    );

    const matchedhardwareEntries = items.filter(
      (entry) =>
        taskProjectIdMatchesOpsManagerResourceScopes(
          { projectid: entry.projectid, taskownerid: entry.taskownerid },
          acceptedProject,
          leadLike
        ) &&
        normalizeTaskIdForScope(entry?.taskownerid) ===
          normalizeTaskIdForScope(currentEmployee._id)
    );
    if (matchedtaskEntries.length) {
      setFilteredEntries(matchedtaskEntries);
    } else if (matchedexpensesEntries.length) {
      setFilteredEntries(matchedexpensesEntries);
    } else if (matchedhardwareEntries.length) {
      setFilteredEntries(matchedhardwareEntries);
    }

    if (effortRowsUserEditing) return;
    if (!initialEdit) {
      if (matchedtaskEntries.length > 0) {
        setRows(matchedtaskEntries.map((entry) => ({ ...entry })));
      } else {
        setRows([{ task: "", hoursassigned: "", notes: "" }]);
      }
    }
  }, [
    autosaveentries,
    employees,
    acceptedProject,
    acceptedProject._id,
    acceptedProject?.groupid,
    acceptedProject?.groupId,
    getProjectGroupId,
    setRows,
    initialEdit,
    tasks,
    items,
    effortRowsUserEditing,
  ]);

  const [operationPersonProject, setOperationPersonProject] = useState([]);

  useEffect(() => {
    setOperationPersonProject(filterRequestProjects); // initial fill or refetch
  }, [filterRequestProjects]);

  const [searchQuery, setSearchQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1); // Track the current page

  const [itemsPerPage] = useState(10);

  const totalItems = operationPersonProject?.length;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;

  // Function to calculate the number of pages
  const totalPages = Math.ceil(operationPersonProject?.length / itemsPerPage);

  // Slice the filteredLeadReport based on the current page
  const currentData = operationPersonProject?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterLeadReports(query);
    setCurrentPage(1);
  };

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = filterRequestProjects.filter((LeadReport) =>
      (getDisplayGroupName(LeadReport) || "")
        .toString()
        .trim()
        .toLowerCase()
        .includes(lowerCaseQuery) ||
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value); // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }

        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setOperationPersonProject(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;

    // Create a deep copy of the current data to avoid mutating state directly
    const sorted = [...operationPersonProject];

    // Helper function for case-insensitive comparison
    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };

    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(a), getDisplayGroupName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(b), getDisplayGroupName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // No sorting needed
        break;
    }

    // Update the state with the sorted array
    setOperationPersonProject(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const handleAddinstallationrow = () => {
    setRowAdded(true);
    if (installation.length >= 15) return; // Maximum 15 rows
    setInstallationUserEditing(true);
    setInstallation([
      ...installation,
      { description: "", value: "", notes: "" },
    ]);
  };

  const handleRemoveinstallationrow = () => {
    // if (installation.length <= 1) return; // Minimum 1 row
    setInstallationUserEditing(true);
    const newRows = [...installation];
    newRows.pop();
    const total = newRows.reduce((sum, row) => {
      return sum + parseAmountNumber(row.value);
    }, 0);
    settotalDollerValue(total);
    setInstallation(newRows);
    setRowAdded(true);
    setTimeout(() => {
      handleinstallationtaskSubmitauto(tripduration, newRows); // Pass the updated rows directly
    }, 2000);
  };

  const handleAddHardware = () => {
    setRowAdded(true);
    if (hardware.length < 15) {
      setHardware([
        ...hardware,
        {
          assemblepartdescription: "",
          partno: "",
          quantity: "",
          unitprice: "",
          totalprice: "",
        },
      ]);
      resetTypingTimeout();
    }
  };

  const handleRemoveHardware = () => {
    const newHardware = [...hardware];
    newHardware.pop();
    setHardware(newHardware);
    setTimeout(() => {
      handlehardCostsAutosaveByOP(newHardware); // Pass the updated rows directly
    }, 2000);
    setRowAdded(true);
  };

  const handlehardwareInputChange = (index, key, value) => {
    const updated = [...hardware];

    if (key === "assemblepartdescription") {
      const selectedPart = fetchedHardwareData.find(
        (item) => item.assemblepartdescription === value
      );

      if (selectedPart) {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: selectedPart.assemblepartdescription,
          partno: selectedPart.partnumber,
          unitprice: selectedPart.unitprice.toString(),
          quantity: "", // Reset quantity to empty
          totalprice: "", // Reset total price since quantity is empty
        };
      } else {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: value,
          partno: "",
          unitprice: "",
          quantity: "", // Reset quantity to empty
          totalprice: "", // Reset total price
        };
      }
    } else if (key === "quantity") {
      const quantity = Number(value);
      const unitprice = Number(updated[index].unitprice || 0);

      updated[index] = {
        ...updated[index],
        quantity: value,
        totalprice:
          !isNaN(quantity) && quantity !== 0
            ? (unitprice * quantity).toFixed(2)
            : "0.00",
      };

      // Check stock availability when quantity is entered (same as manager / OperationHardware)
      if (updated[index].assemblepartdescription && quantity > 0) {
        const matchingInventory = inventory?.find(
          (item) =>
            isInventoryGroupMatch(item, acceptedProject) &&
            item.assembly &&
            item.assembly.trim().toLowerCase() === updated[index].assemblepartdescription.trim().toLowerCase()
        );

        if (matchingInventory) {
          const availableStock = Number(matchingInventory.unitsAvailable || 0);
          if (quantity > availableStock) {
            enqueueSnackbar("Insufficient Stock", {
              variant: "error",
            });
          }
        }
      }
    } else {
      updated[index][key] = value;
    }

    setHardware(updated);

    // Clear existing timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set new timeout for autosave
    const newTimeout = setTimeout(() => {
      handlehardCostsAutosaveByOP(updated);
    }, 3000); // 3 seconds delay

    setTypingTimeout(newTimeout);
  };

  const handlehardCostsAutosaveByOP = React.useCallback(
    async (updatedhardware) => {
      if (isViewOnly) return;
      const transformHardwareData = (hardwareArray) => {
        return hardwareArray.map((item) => ({
          ...item,
          taskstatus: "autosubmit",
        }));
      };
      const transformedData = transformHardwareData(updatedhardware);
      const payload = {
        projectid: acceptedProject._id,
        tasktype: "self",
        tasks: transformedData,
      };
      SetisLoadingtask(true);
      try {
        await dispatch(replaceAllHardwareDescriptions(payload));
      } catch (error) {
        console.error("Error saving hardware data:", error);
      } finally {
        SetisLoadingtask(false);
        handlerefreshagain();
        handlerefresh();
      }
    },
    [
      acceptedProject,
      handlerefresh,
      SetisLoadingtask,
      dispatch,
      handlerefreshagain,
      isViewOnly,
    ]
  );

  const handlehardCostsSubmitByOP = React.useCallback(async () => {
    if (isViewOnly) return;
    const hasEmptyFields = hardware.some((item) => {
      return (
        !item.assemblepartdescription ||
        !item.partno ||
        !item.quantity ||
        !item.totalprice ||
        !item.unitprice
      );
    });

    if (hasEmptyFields) {
      return;
    }
    const transformHardwareData = (hardwareArray) => {
      return hardwareArray.map((item) => ({
        ...item,
        taskstatus: "submit",
      }));
    };

    const transformedData = transformHardwareData(hardware);

    const payload = {
      projectid: acceptedProject._id,
      tasktype: "self",
      tasks: transformedData,
    };
    SetisLoadingtask(true);
    try {
      await dispatch(replaceAllHardwareDescriptions(payload));
    } catch (error) {
      console.error("Error saving hardware data:", error);
    } finally {
      SetisLoadingtask(false);
      setselectedprojectid("");
    }
  }, [hardware, acceptedProject, SetisLoadingtask, dispatch, isViewOnly]);

  const resetTypingTimeout = useCallback(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      handlehardCostsSubmitByOP();
    }, 3000);
    setTypingTimeout(newTimeout);
  }, [typingTimeout, handlehardCostsSubmitByOP]);

  const handleSelectOpen = () => {
    resetTypingTimeout();
  };

  const updatebyname = useCallback(async () => {
    if (isViewOnly) return;
    const serviceType = acceptedProject?.TypeService?.toLowerCase();

    if (serviceType.includes('installation') && !tripduration) {
      return
    }
    const email = localStorage.getItem("email");
    const updatedAssignedperson = (acceptedProject.Assignedperson || [])
      .filter((person) => person.email === email)
      .map((person) => ({
        email: person.email,
        name: person.name,
        taskStatus: "submit",
        isRead: true,
      }));
    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email
    );
    const selectedProjectId = acceptedProject?._id;
    const loggedInUserId = filteredEmployee?._id;
    SetisLoading(true);
    try {
      await dispatch(
        updateTaskStatus({
          projectid: selectedProjectId,
          userid: loggedInUserId,
        })
      );
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      SetisLoading(false);
    }
  }, [dispatch, acceptedProject, tripduration, employees, isViewOnly]);

  // Check if all tasks with task name have hours filled
  const areAllTaskHoursFilled = () => {
    if (!rows || rows.length === 0) return true;
    
    // Filter rows that have a task name filled
    const rowsWithTask = rows.filter(row => 
      row.task && row.task.trim() !== ""
    );
    
    // Check if all rows with task have hours filled
    return rowsWithTask.every(row => 
      row.hoursassigned !== undefined && 
      row.hoursassigned !== null && 
      row.hoursassigned.toString().trim() !== ""
    );
  };

  const handleAction = async () => {
    if (isViewOnly) return;
    syncToolGuideStep("submit");
    SetisLoading(true);

    try {
      const serviceType = acceptedProject?.TypeService?.toLowerCase();

      switch (true) {
        case serviceType.includes("installation"):
          await handledirectSubmit();
          await handleinstallationtaskSubmit(tripduration);
          await updatebyname();
          break;

        case serviceType.includes("hardware"):
          await handlehardCostsSubmitByOP();
          await handletaskSubmit();
          await updatebyname();
          break;

        case serviceType.includes("software"):
        case serviceType.includes("cloud"):
          await handledirectSubmit();
          await handletaskSubmit();
          await updatebyname();
          break;

        default:
          await handledirectSubmit();
          await handletaskSubmit();
          await handlehardCostsSubmitByOP();
          await handleinstallationtaskSubmit(tripduration);
          await updatebyname();
      }
      if (serviceType.includes('installation') && !tripduration) {
        return
      }
      enqueueSnackbar("Response Submitted Successfully.", {
        variant: "success",
      });
    } catch (error) {
      console.error("fwef", error);
    } finally {
      SetisLoading(false);
      // setForwardAction("")
      handlerefresh();
    }
  };

  const [selected, setSelected] = useState(false);
  const ProjectRequestRef = useRef(null);

  useEffect(() => {
    if (selected && ProjectRequestRef.current) {
      // Scroll to the right end of the container
      const scrollToPosition = ProjectRequestRef.current.scrollWidth;
      ProjectRequestRef.current.scrollTo({
        left: scrollToPosition,
        behavior: "smooth",
      });
    }
  }, [selected]);

  const handleProjectread = async (project) => {
    const email = localStorage.getItem("email"); // "yapew30764@miracle3.com"
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const isUserAssigned = project.Assignedperson?.find(
      (person) => person.email === email // replace with your actual logged user email variable
    );
    const projectId = project._id;
    const personId = currentEmployee._id;
    if (isUserAssigned?.isRead === false) {
      try {
        await dispatch(setPersonReadTrue({ projectId, personId }));
      } catch (error) {
        console.error("Failed to reject Project:", error);
      } finally {
        handlerefresh();
      }
    }
  };

  return (
    <>
      <div className={` bg-[#f3f8f8] w-full`}>
        <div className=" relative">
          <div className="">
            <div className="w-full flex gap-2 min-h-[10rem]">
              <div className="w-full pt-2 rounded-lg min-h-full justify-center">
                <div className="flex justify-between items-center rounded-t bg-white py-2 pr-2">
                  <div className=" font-semibold text-md px-2">
                    Project Requested
                  </div>

                  <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                    <MdSearch className=" w-5 h-5 text-gray-500" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                      placeholder="Search"
                      className="bg-[#e0e7ff] outline-none w-[80%]"
                    />
                  </div>
                </div>

                <div
                  ref={ProjectRequestRef}
                  className="flex  w-full overflow-auto bg-white"
                >
                  <div className="w-full">
                    <div className=" head sticky top-0 z-[1400] flex bg-[#E8E8E8]  text-xs justify-between rounded-t-lg font-semibold text-center">
                      <div className="h-14 w-16 flex-shrink-0 pl-3 flex justify-start items-center align-middle bg-[#E8E8E8] text-black">
                        Sr. No
                      </div>
                      <div className="h-14 w-[16.6%] flex-shrink-0 p-2 truncate flex justify-between items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p>Group</p>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer "
                            onClick={() =>
                              sortAlphabetically("AssignedGroup", "az")
                            }
                          >
                            <ArrowDropUp
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() =>
                              sortAlphabetically("AssignedGroup", "za")
                            }
                          >
                            <ArrowDropDown
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="h-14 w-[16.6%] flex-shrink-0 p-2 truncate flex justify-between items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p>Project Name</p>
                        <div className="flex flex-col">
                          <div
                            className="cursor-pointer "
                            onClick={() =>
                              sortAlphabetically("ProjectName", "az")
                            }
                          >
                            <ArrowDropUp
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() =>
                              sortAlphabetically("ProjectName", "za")
                            }
                          >
                            <ArrowDropDown
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="h-14 w-[16.6%] relative flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">

                        Date  Requested
                        <div className="flex flex-col  absolute right-1">
                          <div
                            className="cursor-pointer "
                            onClick={() =>
                              sortAlphabetically("DateRequested", "az")
                            }
                          >
                            <ArrowDropUp
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() =>
                              sortAlphabetically("DateRequested", "za")
                            }
                          >
                            <ArrowDropDown
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="h-14 w-[16.6%] relative flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p className="text-start">Due Date </p>
                        <div className="flex flex-col absolute right-1">
                          <div
                            className="cursor-pointer "
                            onClick={() =>
                              sortAlphabetically("ProjectDueDate", "az")
                            }
                          >
                            <ArrowDropUp
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>

                          <div
                            className="cursor-pointer -mt-2"
                            onClick={() =>
                              sortAlphabetically("ProjectDueDate", "za")
                            }
                          >
                            <ArrowDropDown
                              color="white"
                              sx={{ fontSize: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="h-14 w-[11%] flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p>Attachments</p>
                      </div>
                      <div className="h-14 w-[16.6%] flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                        <p>Action</p>
                      </div>
                      {selectedprojectid && (
                        <div className="h-14 w-[30rem] bg-[#E8E8E8] text-black text-xs flex-shrink-0">
                          <div className="h-[50%] pt-1">TaskList</div>
                          <div className="h-[50%] w-full flex justify-center align-middle items-center">
                            {(Array.isArray(serviceofuser)
                              ? serviceofuser.some((service) =>
                                ["Installation", "Software", "Cloud"].some(
                                  (keyword) => service.includes(keyword)
                                )
                              )
                              : ["Installation", "Software", "Cloud"].some(
                                (keyword) => serviceofuser?.includes(keyword)
                              )) && (
                                <div className="flex w-full">
                                  <div
                                    onClick={() => {
                                      if (!isViewOnly) {
                                        syncToolGuideStep("fill-details");
                                      }
                                      setAction("task");
                                    }}
                                    className={`cursor-pointer flex justify-center align-middle items-center w-[50%] py-1 px-2 ${Action === "task"
                                      ? "bg-blue-500 text-white"
                                      : "bg-[#E8E8E8] text-black"
                                      }`}
                                  >
                                    Effort Expenses
                                  </div>
                                  <div
                                    onClick={() => {
                                      if (!isViewOnly) {
                                        syncToolGuideStep("fill-details");
                                      }
                                      setAction("otherExpenses");
                                    }}
                                    className={`cursor-pointer flex justify-center align-middle items-center w-[50%] py-1 px-2 ${Action === "otherExpenses"
                                      ? "bg-blue-500 text-white"
                                      : "bg-[#E8E8E8] text-black"
                                      }`}
                                  >
                                    Other Expenses
                                  </div>
                                </div>
                              )}

                            {(Array.isArray(serviceofuser)
                              ? serviceofuser.some((service) =>
                                ["Hardware"].some((keyword) =>
                                  service.includes(keyword)
                                )
                              )
                              : ["Hardware"].some((keyword) =>
                                serviceofuser?.includes(keyword)
                              )) && (
                                <div className="flex w-full bg-orange-300">
                                  <div
                                    onClick={() => {
                                      if (!isViewOnly) {
                                        syncToolGuideStep("fill-details");
                                      }
                                      setHardwareAction("hardwarecost");
                                    }}
                                    className={`cursor-pointer flex justify-center align-middle items-center w-[50%] py-1 px-2 ${hardwareAction === "hardwarecost"
                                      ? "bg-blue-500 text-white"
                                      : "bg-[#E8E8E8] text-black"
                                      }`}
                                  >
                                    Hardware Costs
                                  </div>
                                  <div
                                    onClick={() => {
                                      if (!isViewOnly) {
                                        syncToolGuideStep("fill-details");
                                      }
                                      setHardwareAction("otherexpenses");
                                    }}
                                    className={`cursor-pointer  flex justify-center align-middle items-center w-[50%] py-1 px-2 ${hardwareAction === "otherexpenses"
                                      ? "bg-blue-500 text-white"
                                      : "bg-[#E8E8E8] text-black"
                                      }`}
                                  >
                                    Other Expenses
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div
                      ref={maintaskdivRef}
                      className="min-h-[10rem] max-h-[34rem]"
                    >
                      {currentData?.map((project, index) => {
                        const isUserAssigned = project.Assignedperson?.find(
                          (person) => person.email === LoggedUser // replace with your actual logged user email variable
                        );
                        return (
                          <div
                            key={index}
                            className={`flex justify-between ${isUserAssigned?.isRead === false
                              ? "font-bold"
                              : ""
                              } text-center w-full  text-xs`}
                          >
                            <div className="w-16 flex-shrink-0 border-b pl-3 flex justify-start align-middle items-center">
                              {startIdx + index + 1}
                            </div>
                            <div className="w-[16.6%]  flex-shrink-0 border-b p-2 truncate flex justify-start align-middle items-center text-xs line-clamp-2">
                              <p className="truncate ">
                                {getDisplayGroupName(project)}
                              </p>
                            </div>
                            <div className="bg  w-[16.6%]  flex-shrink-0 p-2 border-b truncate flex justify-start align-middle items-center text-xs line-clamp-2">
                              <p className="break-words whitespace-normal text-start">
                                {project.ProjectName}
                              </p>
                            </div>
                            <div className="w-[16.6%]  flex-shrink-0 p-2 border-b truncate flex justify-center align-middle items-center text-xs line-clamp-2">
                              {formatDateByCountry(project.DateRequested)}
                            </div>
                            <div className="w-[16.6%] flex-shrink-0 p-2  border-b truncate flex justify-center align-middle items-center text-xs line-clamp-2">
                              <p className="truncate text-center">
                                {(() => {
                                  const userEmail =
                                    localStorage.getItem("email");
                                  const assignedPerson =
                                    project.Assignedperson.find(
                                      (person) => person.email === userEmail
                                    );
                                  return assignedPerson?.OpDueDate
                                    ? formatDateByCountry(
                                      assignedPerson.OpDueDate
                                    )
                                    : " ";
                                })()}
                              </p>
                            </div>
                            <div className="w-[11%]  flex-shrink-0 p-2 border-b truncate flex justify-center align-middle items-center text-xs line-clamp-2">
                              <FileUploadOP
                                project={project}
                                leads={leads}
                                employees={employees}
                                isViewOnly={isViewOnly}
                              />
                            </div>
                            <div className="w-[16.6%]  flex-shrink-0  border-b flex justify-center align-middle items-center text-center text-xs ">
                              <ActionsOP
                                handleProjectread={handleProjectread}
                                setOpenDetailsIdx={setOpenDetailsIdx}
                                project={project}
                                index={index}
                                SetisLoading={SetisLoading}
                                SetShowprojectDetails={SetShowprojectDetails}
                                setselectedproject={setselectedproject}
                                setselectedprojectid={setselectedprojectid}
                                setAcceptedProject={setAcceptedProject}
                                setServiceofuser={setServiceofuser}
                                setAction={setAction}
                                setSelected={setSelected}
                                selected={selected}
                                employees={employees}
                                handlerefresh={handlerefresh}
                                showprojectDetails={showprojectDetails}
                                isViewOnly={isViewOnly}
                              />
                            </div>

                            {selectedprojectid && (
                              <div
                                className={` 
                                 w-[30rem] border-b text-xs flex-shrink-0 custom-scroll ${selectedprojectid === project._id
                                    ? "min-h-[20vh]"
                                    : ""
                                  }  max-h-[53vh] overflow-auto`}
                              >
                                {openDetailsIdx === index && (
                                  <div className="w-full">
                                    {(Action === "otherExpenses" ||
                                      hardwareAction === "otherexpenses") && (
                                        <>
                                          {(Array.isArray(
                                            acceptedProject.TypeService
                                          )
                                            ? acceptedProject.TypeService.some(
                                              (service) =>
                                                [
                                                  "Software",
                                                  "Cloud",
                                                  "Hardware",
                                                ].some((keyword) =>
                                                  service.includes(keyword)
                                                )
                                            )
                                            : [
                                              "Software",
                                              "Cloud",
                                              "Hardware",
                                            ].some((keyword) =>
                                              acceptedProject.TypeService?.includes(
                                                keyword
                                              )
                                            )) && (
                                              <div className=" maintaskdiv w-full bg-white">
                                                <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                                                  {/* Table Header */}
                                                  <div className="flex flex-col w-full">
                                                    <div className="w-full">
                                                      <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                                                        <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                                          Sr. No
                                                        </div>
                                                        <div className="w-[40%] border p-2">
                                                          Description
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          Amount ({currency})
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          Notes
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="w-full">
                                                      <div className="head flex text-center text-xs">
                                                        <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                                                        <div className="w-[40%] border p-2">
                                                          Total
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          {formatAmountComma(
                                                            totalDollerValue +
                                                              (shouldShowLockedTrainingRow
                                                                ? lockedTrainingCostTotal
                                                                : 0)
                                                          )}
                                                        </div>
                                                        <div className="w-[25%] border p-2"></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="w-full">
                                                    {triprows.map((row, index) => {
                                                      const isOpTrainingCostRow =
                                                        isTrainingExpenseDisplayRow(row);
                                                      const otherExpenseReadOnly =
                                                        isViewOnly || isOpTrainingCostRow;
                                                      const readOnlyRowClass =
                                                        "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed";
                                                      return (
                                                      <React.Fragment key={index}>
                                                        {Assignperson?.taskStatus ===
                                                          "submit" ? (
                                                          <div className="flex items-center text-center w-full text-xs">
                                                            <div className="w-full">
                                                              <div className="head flex">
                                                                <div className="w-[10%] border p-1">
                                                                  {index + 1}
                                                                </div>

                                                                <div className="w-[40%] border p-2">
                                                                  {row.description}
                                                                </div>

                                                                <div className="w-[25%] border p-2">
                                                                  {formatAmountComma(
                                                                    row.value
                                                                  )}
                                                                </div>

                                                                <div className="w-[25%] border p-2">
                                                                  {row.notes}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ) : (
                                                          <div className="flex items-center text-center w-full text-xs">
                                                            <div className="w-full">
                                                              <div className="head flex">
                                                                <div className="w-[10%] border p-1">
                                                                  {index + 1}
                                                                </div>

                                                                <div className="w-[40%] border p-2">
                                                                  <input
                                                                    type="text"
                                                                    name="description"
                                                                    value={
                                                                      row.description
                                                                    }
                                                                    onChange={(e) =>
                                                                      handleInputChanged(
                                                                        index,
                                                                        "description",
                                                                        validateDescriptionOrNotes(
                                                                          e.target
                                                                            .value
                                                                        )
                                                                      )
                                                                    }
                                                                    disabled={otherExpenseReadOnly}
                                                                    className={`outline-none border-none text-center w-full h-full ${otherExpenseReadOnly ? readOnlyRowClass : ""}`}
                                                                  />
                                                                </div>

                                                                <div className="w-[25%] border p-2">
                                                                  <input
                                                                    type="text"
                                                                    name="value"
                                                                    value={formatAmountForInput(
                                                                      row.value
                                                                    )}
                                                                    onChange={(e) =>
                                                                      handleInputChanged(
                                                                        index,
                                                                        "value",
                                                                        e.target.value
                                                                      )
                                                                    }
                                                                    onKeyDown={(
                                                                      e
                                                                    ) => {
                                                                      if (
                                                                        [
                                                                          "e",
                                                                          "E",
                                                                          "+",
                                                                          "-",
                                                                        ].includes(
                                                                          e.key
                                                                        )
                                                                      ) {
                                                                        e.preventDefault();
                                                                      }
                                                                    }}
                                                                    disabled={otherExpenseReadOnly}
                                                                    className={`outline-none border-none text-center w-full h-full ${otherExpenseReadOnly ? readOnlyRowClass : ""}`}
                                                                  />
                                                                </div>

                                                                <div className="w-[25%] border p-2">
                                                                  <input
                                                                    type="text"
                                                                    name="notes"
                                                                    value={
                                                                      row.notes
                                                                    }
                                                                    onChange={(e) =>
                                                                      handleInputChanged(
                                                                        index,
                                                                        "notes",
                                                                        validateDescriptionOrNotes(
                                                                          e.target
                                                                            .value
                                                                        )
                                                                      )
                                                                    }
                                                                    disabled={otherExpenseReadOnly}
                                                                    className={`outline-none border-none text-center w-full h-full ${otherExpenseReadOnly ? readOnlyRowClass : ""}`}
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}

                                                      </React.Fragment>
                                                    );
                                                    })}
                                                    {shouldShowLockedTrainingRow && lockedTrainingRow && (
                                                      <div className="flex items-center text-center w-full text-xs">
                                                        <div className="w-full">
                                                          <div className="head flex">
                                                            <div className="w-[10%] border p-1">
                                                              {(triprows?.length || 0) + 1}
                                                            </div>
                                                            <div className="w-[40%] border p-2">
                                                              {lockedTrainingRow.description}
                                                            </div>
                                                            <div className="w-[25%] border p-2">
                                                              {formatAmountComma(lockedTrainingRow.amount)}
                                                            </div>
                                                            <div className="w-[25%] border p-2">
                                                              {lockedTrainingRow.notes}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}

                                                    {/* Add / Remove Buttons (always below the last row, including Training Cost) */}
                                                    {Assignperson?.taskStatus !== "submit" && (
                                                      <div className="flex justify-between px-2 pt-1">
                                                        <button
                                                          className={`shadow-xl rounded-md p-1 add-row-button ${
                                                            isViewOnly
                                                              ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                                                              : ""
                                                          }`}
                                                          onClick={handleAddRows}
                                                          disabled={isViewOnly || triprows.length >= 15}
                                                        >
                                                          <AddIcon />
                                                        </button>
                                                        <button
                                                          className={`shadow-xl rounded-md p-1 ${
                                                            isViewOnly ||
                                                            (triprows.length > 0 &&
                                                              isTrainingExpenseDisplayRow(
                                                                triprows[triprows.length - 1]
                                                              ))
                                                              ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                                                              : ""
                                                          }`}
                                                          onClick={handleRemoveRows}
                                                          disabled={
                                                            isViewOnly ||
                                                            (triprows.length > 0 &&
                                                              isTrainingExpenseDisplayRow(
                                                                triprows[triprows.length - 1]
                                                              ))
                                                          }
                                                        >
                                                          <RemoveIcon />
                                                        </button>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                          {/* {acceptedProject.TypeService ===
                                                    "Installation" && */}
                                          {(Array.isArray(
                                            acceptedProject.TypeService
                                          )
                                            ? acceptedProject.TypeService.some(
                                              (service) =>
                                                service.includes("Installation")
                                            )
                                            : acceptedProject.TypeService?.includes(
                                              "Installation"
                                            )) &&
                                            Action === "otherExpenses" && (
                                              <div
                                                className=" maintaskdiv w-full bg-white"
                                              // ref={installationtaskdiv}
                                              >
                                                <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                                                  <div className="flex flex-col w-full">
                                                    <div className="w-full">
                                                      <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                                                        <div className="w-[50%] border p-2 font-semibold">
                                                          Trip Duration (Days)
                                                        </div>
                                                        <div className="w-[50%] border p-2">
                                                          {Assignperson?.taskStatus ===
                                                            "submit" ? (
                                                            <>{tripduration}</>
                                                          ) : (
                                                            <input
                                                              type="text"
                                                              value={tripduration}
                                                              onChange={(e) => {
                                                                const numericValue =
                                                                  e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    ""
                                                                  );

                                                                handletripdurationChange(
                                                                  numericValue
                                                                );
                                                              }}
                                                              placeholder="Enter duration"
                                                              disabled={isViewOnly}
                                                              className={`h-full w-full outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-[#1973eb]"}`}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="w-full">
                                                      <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                                                        <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                                          Sr. No
                                                        </div>
                                                        <div className="w-[40%] border p-2">
                                                          Description
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          Amount ({currency})
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          Notes
                                                        </div>
                                                      </div>
                                                      <div className="head flex text-center text-xs">
                                                        <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                                                        <div className="w-[40%] border p-2">
                                                          Total
                                                        </div>
                                                        <div className="w-[25%] border p-2">
                                                          {formatAmountComma(
                                                            totalDollerValue +
                                                              (shouldShowLockedTrainingRow
                                                                ? lockedTrainingCostTotal
                                                                : 0)
                                                          )}
                                                        </div>
                                                        <div className="w-[25%] border p-2"></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="w-full">
                                                    {installation.map((row, index) => {
                                                      const isOpTrainingCostRow =
                                                        isTrainingExpenseDisplayRow(row);
                                                      const otherExpenseReadOnly =
                                                        isViewOnly || isOpTrainingCostRow;
                                                      const readOnlyRowClass =
                                                        "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed";
                                                      return (
                                                        <React.Fragment
                                                          key={index}
                                                        >
                                                          {Assignperson?.taskStatus ===
                                                            "submit" ? (
                                                            <div className="flex items-center text-center w-full text-xs">
                                                              <div className="w-full">
                                                                <div className="head flex">
                                                                  <div className="w-[10%] border p-1">
                                                                    {index + 1}
                                                                  </div>
                                                                  <div className="w-[40%] border p-2">
                                                                    {
                                                                      row.description
                                                                    }
                                                                  </div>
                                                                  <div className="w-[25%] border p-2">
                                                                    {formatAmountComma(
                                                                      row.value
                                                                    )}
                                                                  </div>
                                                                  <div className="w-[25%] border p-2">
                                                                    {row.notes}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          ) : (
                                                            <div className="flex items-center text-center w-full text-xs">
                                                              <div className="w-full">
                                                                <div className="head flex">
                                                                  <div className="w-[10%] border p-1">
                                                                    {index + 1}
                                                                  </div>
                                                                  <div className="w-[40%] border p-2">
                                                                    <input
                                                                      type="text"
                                                                      name="description"
                                                                      value={
                                                                        row.description
                                                                      }
                                                                      placeholder="Enter Value"
                                                                      onKeyDown={(
                                                                        e
                                                                      ) => {
                                                                        if (
                                                                          [
                                                                            "+",
                                                                            "-",
                                                                          ].includes(
                                                                            e.key
                                                                          )
                                                                        ) {
                                                                          e.preventDefault();
                                                                        }
                                                                      }}
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        const Value =
                                                                          e.target
                                                                            .value;
                                                                        handleInstallationChange(
                                                                          index,
                                                                          "description",
                                                                          Value
                                                                        );
                                                                      }}
                                                                      disabled={otherExpenseReadOnly}
                                                                      className={`outline-none border-none text-center w-full h-full ${otherExpenseReadOnly ? readOnlyRowClass : ""}`}
                                                                    />
                                                                  </div>
                                                                  <div className="w-[25%] border p-2">
                                                                    <input
                                                                      type="text"
                                                                      name="value"
                                                                      value={formatAmountForInput(
                                                                        row.value
                                                                      )}
                                                                      placeholder="Enter Value"
                                                                      onFocus={(e) => {
                                                                        if (e.target.value === "0") e.target.select();
                                                                      }}
                                                                      onClick={(e) => {
                                                                        if (e.target.value === "0") e.target.select();
                                                                      }}
                                                                      onKeyDown={(
                                                                        e
                                                                      ) => {
                                                                        if (
                                                                          [
                                                                            "e",
                                                                            "E",
                                                                            "+",
                                                                            "-",
                                                                          ].includes(
                                                                            e.key
                                                                          )
                                                                        ) {
                                                                          e.preventDefault();
                                                                        }
                                                                      }}
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        handleInstallationChange(
                                                                          index,
                                                                          "value",
                                                                          e.target.value
                                                                        );
                                                                      }}
                                                                      disabled={otherExpenseReadOnly}
                                                                      className={`outline-none border-none text-center w-full h-full ${otherExpenseReadOnly ? readOnlyRowClass : ""}`}
                                                                    />
                                                                  </div>
                                                                  <div className="w-[25%] border p-2">
                                                                    <input
                                                                      type="text"
                                                                      name="notes"
                                                                      value={
                                                                        row.notes
                                                                      }
                                                                      placeholder="Enter Notes"
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        const validValue =
                                                                          e.target.value.replace(
                                                                            /[^a-zA-Z0-9 ]/g,
                                                                            ""
                                                                          );
                                                                        handleInstallationChange(
                                                                          index,
                                                                          "notes",
                                                                          validValue
                                                                        );
                                                                      }}
                                                                      disabled={otherExpenseReadOnly}
                                                                      className={`outline-none border-none text-center w-full h-full ${otherExpenseReadOnly ? readOnlyRowClass : ""}`}
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )}

                                                          {index ===
                                                            installation.length -
                                                            1 &&
                                                            (Assignperson?.taskStatus ===
                                                              "submit" ? (
                                                              <> </>
                                                            ) : (
                                                              <div className="flex justify-between px-2 pt-1">
                                                                <button
                                                                  className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none" : ""}`}
                                                                  onClick={
                                                                    handleAddinstallationrow
                                                                  }
                                                                  disabled={
                                                                    isViewOnly || triprows.length >=
                                                                    15
                                                                  }
                                                                >
                                                                  <AddIcon />
                                                                </button>
                                                                <button
                                                                  className={`shadow-xl rounded-md p-1 ${
                                                                    isViewOnly ||
                                                                    (installation.length > 0 &&
                                                                      isTrainingExpenseDisplayRow(
                                                                        installation[installation.length - 1]
                                                                      ))
                                                                      ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                                                                      : ""
                                                                  }`}
                                                                  onClick={
                                                                    handleRemoveinstallationrow
                                                                  }
                                                                  disabled={
                                                                    isViewOnly ||
                                                                    (installation.length > 0 &&
                                                                      isTrainingExpenseDisplayRow(
                                                                        installation[installation.length - 1]
                                                                      ))
                                                                  }
                                                                >
                                                                  <RemoveIcon />
                                                                </button>
                                                              </div>
                                                            ))}
                                                        </React.Fragment>
                                                      );
                                                    })}
                                                    {shouldShowLockedTrainingRow && lockedTrainingRow && (
                                                      <div className="flex items-center text-center w-full text-xs">
                                                        <div className="w-full">
                                                          <div className="head flex">
                                                            <div className="w-[10%] border p-1">
                                                              {(installation?.length || 0) + 1}
                                                            </div>
                                                            <div className="w-[40%] border p-2">
                                                              {lockedTrainingRow.description}
                                                            </div>
                                                            <div className="w-[25%] border p-2">
                                                              {formatAmountComma(lockedTrainingRow.amount)}
                                                            </div>
                                                            <div className="w-[25%] border p-2">
                                                              {lockedTrainingRow.notes}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                        </>
                                      )}

                                    {Action === "task" && (
                                      <div className="w-full bg-white rounded-lg justify-center pb-5">
                                        <div className="flex w-full">
                                          <div className="w-full">
                                            <div className="head flex w-full text-center bg-[#3b82f6] text-white text-xs">
                                              <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                                Sr. No
                                              </div>
                                              <div className="w-[40%] border p-2">
                                                Task
                                              </div>
                                              <div className="w-[25%] border p-2">
                                                Hours
                                              </div>
                                              <div className="w-[25%] border p-2">
                                                Notes
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex text-center w-full text-xs">
                                          <div className="w-full">
                                            <div className="head flex">
                                              <div className="w-[10%] border p-1"></div>

                                              <div className="w-[40%] border p-2">
                                                Total
                                              </div>
                                              <div className="w-[25%] border p-2">
                                                {totalHoursAssigned}
                                              </div>
                                              <div className="w-[25%] border p-2"></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="w-full">
                                          {rows.map((row, index) => (
                                            <>
                                              {Assignperson?.taskStatus ===
                                                "submit" ? (
                                                <div
                                                  className="flex items-center text-center w-full text-xs"
                                                  key={index}
                                                >
                                                  <div className="w-full">
                                                    <div className="head flex">
                                                      <div className="w-[10%] border p-1">
                                                        {index + 1}
                                                      </div>
                                                      <div className="w-[40%] border p-2">
                                                        {row.task}
                                                      </div>
                                                      <div className="w-[25%] border p-2">
                                                        {row.hoursassigned}
                                                      </div>
                                                      <div className="w-[25%] border p-2">
                                                        {row.notes}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div
                                                  className="flex items-center text-center w-full text-xs"
                                                  key={index}
                                                >
                                                  <div className="w-full">
                                                    <div className="head flex">
                                                      <div className="w-[10%] border p-1">
                                                        {index + 1}
                                                      </div>
                                                      <div className="w-[40%] border p-2">
                                                        <input
                                                          type="text"
                                                          name="task"
                                                          value={row.task}
                                                          onChange={(e) =>
                                                            handleInputChangeTracked(
                                                              index,
                                                              e
                                                            )
                                                          }
                                                          disabled={isViewOnly}
                                                          className={`outline-none border-none text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                        />
                                                      </div>
                                                      <div className="w-[25%] border p-2">
                                                        <input
                                                          type="text"
                                                          name="hoursassigned"
                                                          value={
                                                            row.hoursassigned
                                                          }
                                                          onKeyDown={(e) => {
                                                            if (
                                                              [
                                                                "e",
                                                                "E",
                                                                "+",
                                                                "-",
                                                              ].includes(e.key)
                                                            ) {
                                                              e.preventDefault();
                                                            }
                                                          }}
                                                          onChange={(e) =>
                                                            handleInputChangeTracked(
                                                              index,
                                                              e
                                                            )
                                                          }
                                                          disabled={isViewOnly}
                                                          className={`outline-none border-none text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                        />
                                                      </div>
                                                      <div className="w-[25%] border p-2">
                                                        <input
                                                          type="text"
                                                          name="notes"
                                                          value={row.notes}
                                                          onChange={(e) =>
                                                            handleInputChangeTracked(
                                                              index,
                                                              e
                                                            )
                                                          }
                                                          disabled={isViewOnly}
                                                          className={`outline-none border-none text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}

                                              {/* {rowstatus !== "submit" && ( */}
                                              {Assignperson?.taskStatus ===
                                                "submit" ? (
                                                <></>
                                              ) : (
                                                <div className="flex justify-between">
                                                  <div className="">
                                                    {index ===
                                                      rows.length - 1 && (
                                                        <button
                                                          className={`shadow-xl rounded-md p-1 add-row-button ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none" : ""}`}
                                                          onClick={
                                                            handleAddRowTracked
                                                          }
                                                          disabled={isViewOnly}
                                                        >
                                                          <AddIcon />
                                                        </button>
                                                      )}
                                                  </div>
                                                  <div className="">
                                                    {index ===
                                                      rows.length - 1 && (
                                                        <button
                                                          className={`right-1 shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none" : ""}`}
                                                          onClick={() =>
                                                            handleRemoveRow(index)
                                                          }
                                                          disabled={isViewOnly}
                                                        >
                                                          <RemoveIcon />
                                                        </button>
                                                      )}
                                                  </div>
                                                </div>
                                              )}
                                              {/* )} */}
                                            </>
                                          ))}
                                        </div>
                                      </div>
                                    )}

                                    {hardwareAction === "hardwarecost" && (
                                      <div className="mainhardwarekdiv w-full bg-white">
                                        <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                                          {/* Table Header */}
                                          <div className="flex flex-col w-full">
                                            <div className="w-full">
                                              <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                                                <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                                  Sr. No
                                                </div>
                                                <div className="w-60 border py-1 break-words">
                                                  Assembly/Part Description
                                                </div>
                                                <div className="w-[20%] border p-1">
                                                  Part No
                                                </div>
                                                <div className="w-[20%] border p-1">
                                                  Quantity
                                                </div>
                                                <div className="w-[20%] border p-1">
                                                  Unit Cost ({currency})
                                                </div>
                                                <div className="w-[20%] border p-1">
                                                  Total Cost ({currency})
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="w-full">
                                            {hardware?.map((row, index) => (
                                              <React.Fragment key={index}>
                                                {Assignperson?.taskStatus ===
                                                  "submit" ? (
                                                  <div className="flex items-center text-center w-full text-xs">
                                                    <div className="w-full">
                                                      <div className="head flex">
                                                        <div className="w-[10%] border p-1">
                                                          {index + 1}
                                                        </div>

                                                        {/* Description Select */}
                                                        <div className="w-60 border p-1">
                                                          {
                                                            row.assemblepartdescription
                                                          }
                                                        </div>
                                                        {/* Part Number */}
                                                        <div className="w-[20%] border p-1">
                                                          {row.partno}
                                                        </div>

                                                        {/* Quantity Input */}
                                                        <div className="w-[20%] border p-1">
                                                          {row.quantity}
                                                        </div>

                                                        {/* Unit Price */}
                                                        <div className="w-[20%] border p-1">
                                                          {USAComma(
                                                            row.unitprice
                                                          )}
                                                        </div>

                                                        {/* Total Price */}
                                                        <div className="w-[20%] border p-1">
                                                          {USAComma(
                                                            row.totalprice
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div className="flex items-center text-center w-full text-xs">
                                                    <div className="w-full">
                                                      <div className="head flex">
                                                        <div className="w-[10%] border p-1">
                                                          {index + 1}
                                                        </div>

                                                        {/* Description Select */}
                                                        <div className="w-60 border p-1">
                                                          <select
                                                            name="assemblepartdescription"
                                                            value={
                                                              row.assemblepartdescription ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handlehardwareInputChange(
                                                                index,
                                                                "assemblepartdescription",
                                                                e.target.value
                                                              )
                                                            }
                                                            onFocus={
                                                              handleSelectOpen
                                                            }
                                                            disabled={isViewOnly}
                                                            className={`outline-none text-black bg-white border-none text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                          >
                                                            <option
                                                              hidden
                                                              value=""
                                                            >
                                                              Select
                                                            </option>
                                                            {fetchedHardwareData?.map(
                                                              (option) => {
                                                                const isAlreadySelected =
                                                                  hardware.some(
                                                                    (row, i) =>
                                                                      row.assemblepartdescription ===
                                                                      option.assemblepartdescription &&
                                                                      i !==
                                                                      index
                                                                  );

                                                                return (
                                                                  <option
                                                                    key={
                                                                      option._id
                                                                    }
                                                                    value={
                                                                      option.assemblepartdescription
                                                                    }
                                                                    disabled={
                                                                      isAlreadySelected
                                                                    }
                                                                  >
                                                                    {
                                                                      option.assemblepartdescription
                                                                    }
                                                                  </option>
                                                                );
                                                              }
                                                            )}
                                                          </select>
                                                        </div>

                                                        {/* Part Number */}
                                                        <div className="w-[20%] border p-1">
                                                          {row.partno || ""}
                                                        </div>

                                                        {/* Quantity Input */}
                                                        <div className="w-[20%] border p-1">
                                                          <input
                                                            type="number"
                                                            placeholder="enter quantity"
                                                            value={
                                                              row.quantity || ""
                                                            }
                                                            onChange={(e) => {
                                                              let value =
                                                                e.target.value;

                                                              if (
                                                                /^\d*\.?\d{0,3}$/.test(
                                                                  value
                                                                ) ||
                                                                value === ""
                                                              ) {
                                                                handlehardwareInputChange(
                                                                  index,
                                                                  "quantity",
                                                                  value
                                                                );
                                                              }
                                                            }}
                                                            onKeyDown={(e) => {
                                                              if (
                                                                !(
                                                                  (e.key >=
                                                                    "0" &&
                                                                    e.key <=
                                                                    "9") ||
                                                                  e.key ===
                                                                  "." ||
                                                                  e.key ===
                                                                  "Backspace" ||
                                                                  e.key ===
                                                                  "Delete" ||
                                                                  e.key ===
                                                                  "ArrowLeft" ||
                                                                  e.key ===
                                                                  "ArrowRight" ||
                                                                  e.key ===
                                                                  "Tab"
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                              }
                                                            }}
                                                            disabled={isViewOnly}
                                                            className={`w-full h-full border text-center border-gray-300 rounded-md p-0.5 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                          />
                                                        </div>

                                                        {/* Unit Price */}
                                                        <div className="w-[20%] border p-1">
                                                          {USAComma(
                                                            row.unitprice
                                                          ) || ""}
                                                        </div>

                                                        {/* Total Price */}
                                                        <div className="w-[20%] border p-1">
                                                          {USAComma(
                                                            row.totalprice || ""
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </React.Fragment>
                                            ))}

                                            {/* Add/Remove Buttons */}
                                            {Assignperson?.taskStatus ===
                                              "submit" ? (
                                              <></>
                                            ) : (
                                              <div className="flex justify-between px-2 pt-1">
                                                <button
                                                  className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none" : ""}`}
                                                  onClick={handleAddHardware}
                                                  disabled={
                                                    isViewOnly || hardware.length >= 15
                                                  }
                                                >
                                                  <AddIcon />
                                                </button>
                                                <button
                                                  className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none" : ""}`}
                                                  onClick={handleRemoveHardware}
                                                  disabled={isViewOnly}
                                                >
                                                  <RemoveIcon />
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>

                                      // <HardwareCost
                                      //   acceptedProject={
                                      //     acceptedProject
                                      //   }
                                      //   submitstate={submitstate}
                                      //   SetisLoadingtask={
                                      //     SetisLoadingtask
                                      //   }
                                      // />
                                    )}

                                    {/* {hardwareAction ===
                                                "otherexpenses" && (
                                                  <OtherExpensesHard
                                                    acceptedProject={
                                                      acceptedProject
                                                    }
                                                    submitstate={submitstate}
                                                    SetisLoadingtask={
                                                      SetisLoadingtask
                                                    }
                                                    setsubmitstate={
                                                      setsubmitstate
                                                    }

                                                  // setexpensestatus={setexpensestatus}
                                                  />
                                                )} */}
                                    {/* {rowstatus !== "submit" && ( */}

                                    {Assignperson?.taskStatus === "submit" ? (
                                      <></>
                                    ) : (
                                      <div className="submitbtn flex gap-2 justify-end py-1">
                                        {isLoadingtask && (
                                          <div className="mt-4 flex gap-1 align-middle items-center">
                                            <div className="text-sm">
                                              Saving Tasks{" "}
                                            </div>
                                            <SubmitLoader
                                              isLoadingtask={isLoadingtask}
                                            />
                                          </div>
                                        )}
                                        {filteredEntries?.length > 0 && (
                                          <button
                                            onClick={() => {
                                              if (isViewOnly) return;
                                              if (!areAllTaskHoursFilled()) {
                                                enqueueSnackbar("Please fill all the field.", {
                                                  variant: "error",
                                                });
                                                return;
                                              }
                                              handleAction();
                                            }}
                                            disabled={isViewOnly}
                                            className={`mt-4 px-4 py-2 rounded-md ${
                                              isViewOnly
                                                ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                                                : !areAllTaskHoursFilled()
                                                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                                                  : "bg-blue-600 text-white hover:bg-blue-700"
                                            }`}
                                          >
                                            Submit
                                          </button>
                                        )}

                                        {/* {(Array.isArray(
                                                  acceptedProject.TypeService
                                                )
                                                  ? acceptedProject.TypeService.some(
                                                    (service) =>
                                                      service.includes(
                                                        "Hardware"
                                                      )
                                                  )
                                                  : acceptedProject.TypeService?.includes(
                                                    "Hardware"
                                                  )) && (

                                                    <button
                                                      // onClick={handleCreateTask}
                                                      onClick={() => {
                                                        handleAction();
                                                      }}
                                                      className="mt-4 px-4 py-2 bg-blue-600 text-white hover:bg-blue-300 rounded-md"
                                                    >
                                                      Submit
                                                    </button>
                                                  )} */}
                                      </div>
                                    )}

                                    {/* )} */}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}

                      {currentData?.length === 0 && (
                        <div className="noDataAvailable p-2">
                          No Result Found
                        </div>
                      )}
                    </div>
                  </div>

                  {viewTaskSubmitted && (
                    <div className="w-[30rem]">
                      <div className="w-full bg-white rounded-lg h-full justify-center min-h-[60vh]  pb-5">
                        <div className="flex w-full">
                          <div className="w-full">
                            <div className="head flex text-center bg-[#E8E8E8] text-black text-xs">
                              <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                                Sr. No
                              </div>
                              <div className="w-[40%] border p-2">Task</div>
                              <div className="w-[20%] border p-2">Hours</div>
                              <div className="w-[25%] border p-2">Notes</div>
                            </div>
                          </div>
                        </div>

                        <div className="w-full">
                          {taskToShow.map((row, index) => (
                            <>
                              <div
                                className="flex items-center text-center w-full text-xs"
                                key={index}
                              >
                                <div className="w-full">
                                  <div className="head flex">
                                    <div className="w-[10%] border p-1">
                                      {index + 1}
                                    </div>
                                    <div className="w-[40%] border p-2">
                                      {row.task}
                                    </div>
                                    <div className="w-[20%] border p-2">
                                      {row.hoursassigned}
                                    </div>
                                    <div className="w-[25%] border p-2">
                                      {row.notes}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {currentData?.length > 0 && (
                  <div className="pagination flex justify-between items-center bg-white rounded-b-md p-2 text-[12px]">
                    <div>
                      {totalItems > 0 ? (
                        <>
                          Showing {startIdx + 1} to{" "}
                          {Math.min(endIdx, totalItems)} of {totalItems} Entries
                        </>
                      ) : (
                        <>Showing 0 Entries</>
                      )}
                    </div>
                    {totalPages > 1 && (
                      <div>
                        <button
                          onClick={() => setCurrentPage(1)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === 1}
                          title="First Page"
                        >
                          <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === 1}
                        >
                          <ChevronRightIcon className="w-5 h-5 rotate-180" />

                          {/* Previous */}
                        </button>

                        {Array.from({ length: 3 }, (_, index) => {
                          // Calculate the page number for the current range
                          const pageNumber = currentPage - 1 + index;

                          // Ensure the pageNumber stays within bounds
                          if (pageNumber >= 1 && pageNumber <= totalPages) {
                            return (
                              <button
                                key={pageNumber}
                                onClick={() => setCurrentPage(pageNumber)}
                                className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                                  ? "bg-gray-300"
                                  : ""
                                  }`}
                              >
                                {pageNumber}
                              </button>
                            );
                          }

                          // Return null for out-of-bounds values
                          return null;
                        })}

                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === totalPages}
                        >
                          <ChevronRightIcon className="w-5 h-5" />
                          {/* Next */}
                        </button>

                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === totalPages}
                          title="Last Page"
                        >
                          <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
    </>
  );
};

export default ProjectRequestedOP;
